module.exports = __webpack_public_path__ + "img/108013.ab101440.png";